import { render, staticRenderFns } from "./GymSelect.vue?vue&type=template&id=36f525ec&scoped=true&"
import script from "./GymSelect.vue?vue&type=script&lang=js&"
export * from "./GymSelect.vue?vue&type=script&lang=js&"
import style0 from "./GymSelect.vue?vue&type=style&index=0&id=36f525ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f525ec",
  null
  
)

export default component.exports